import { primaryLayoutConfig } from '../components/layouts/PrimaryLayout'
import { SizeChartsPage } from '../components/pages/SizeChartsPage'

SizeChartsPage.layoutConfig = primaryLayoutConfig

export default SizeChartsPage
